export enum LibraryModalType {
  DOWNLOAD = 'download',
}
